import React, { useContext, useState, useEffect, useMemo, useRef } from 'react'
import AuthContext from '../../context/AuthContext'
import { Tile, Form, FormGroup, TextInput, Button, Select, SelectItem } from 'carbon-components-react'
import { useHistory } from 'react-router-dom'
import { CSVLink } from "react-csv"
import { handleDeNorm, normalizePhone, deNormalizePhone, handleNorm } from '../../utils/functions/tools/normalizePhone';
import ClientNav from '../../components/clientNav';
import { ClientNotesList } from './clientNotes.tsx';
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const ClientNotes = (pageData) => {

    const [totalItems, setTotalItems] = useState(0);
    const [firstRowIndex, setFirstRowIndex] = useState(0);
    const [currentPageSize, setCurrentPageSize] = useState(10);

    // Variables for modals and toasts
    const [error, setError] = useState(false);
    const [editNoteID, setEditNoteID] = useState(null);
    const [deleteNoteID, setDeleteNoteID] = useState(null);
    const [openAddNoteModal, setOpenAddNoteModal] = useState(false);
    const addNoteForm = useRef();
    const [openEditNoteModal, setOpenEditNoteModal] = useState(false);
    const editNoteForm = useRef();
    const [openDeleteNoteModal, setOpenDeleteNoteModal] = useState(false);

    // Variables for noteSearch
    let [client, setClient] = useState(null)
    const [noteSearch, setNoteSearch] = useState("");

    // Other Variables
    let { user } = useContext(AuthContext)
    let [notes, setNotes] = useState([])
    useEffect(() => {
        getNotes()
        document.title = "Client Notes | WillowBMS"
    }, [pageData.profileId])

    // Notes Functions
    let getNotes = async () => {
        let response = await fetch(`${API_URL}/client/notes/manage/${pageData.profileId}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            }
        })
        let data = await response.json()
        setNotes(data)
    }

    let handleAddNote = async (values) => {
        values.preventDefault()
        let response = await fetch(`${API_URL}/client/notes/manage/${pageData.profileId}/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            },
            body: JSON.stringify({
                'authUser_id': user.id,
                'note': values.target.note.value
            })
        })

        if (response.status === 200) {
            getNotes()
            setOpenAddNoteModal(false)
            pageData.showToast("success", "Success", "Client note has been added.")
            document.getElementById("addNote").reset()
        } else {
            setError(true)
        }
    }

    let editNoteSetup = async (id) => {
        notes.map((note)=> {note.id === id && setEditNoteID(note)})
    }

    let handleEditNote = async (values) => {
        values.preventDefault()
        let response = await fetch(`${API_URL}/client/notes/manage/${editNoteID.id}/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            },
            body: JSON.stringify({
                'id': editNoteID.id,
                'note': values.target.note.value,
                'authUser': user.id
            })
        })

        if (response.status === 200) {
            getNotes()
            setOpenEditNoteModal(false)
            pageData.showToast("success", "Success", "Client note has been added.")
        } else {
            setError(true)
        }
    }

    let deleteNote = async (noteID) => {
        let response = await fetch(`${API_URL}/client/notes/manage/${noteID}/`, {
            method: 'DELETE',
            'headers': {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + pageData.authTokens?.access
            }
        })

        if (response.status === 200) {
            getNotes()
            setOpenDeleteNoteModal(false)
            let toastMessage = "Client note #" + noteID + " has been deleted."
            pageData.showToast("success", "Success", toastMessage)
        } else {
            setError(true)
        }
    }

    // Search
    const notesData = useMemo(() => {
        let computedNotes = search(notes);
        setTotalItems(computedNotes.length);
        //Current Page slice
        return computedNotes.slice(
            firstRowIndex,
            firstRowIndex + currentPageSize
        );
    }, [notes, firstRowIndex, currentPageSize, noteSearch]);

    function search(notes) {
        return notes.filter(
            (row) =>
                row.note.indexOf(noteSearch) > -1 ||
                row.note.toLowerCase().indexOf(noteSearch) > -1 
        );
    }

    // Reports
    const notesHeaders = [
        { label: "ID", key: "id" },
        { label: "Date", key: "date" },
        { label: "Note", key: "note" },
        { label: "Client ID", key: "client_id" }
    ];

    const noteReport = {
        data: notes,
        headers: notesHeaders,
        filename: `notes_${client?.company}_notes_${pageData.profileId}_report.csv`
    };

    return (
        <Tile light={true} className="row">
            <h5>Notes</h5>
            <p className="mb-1 text-sm">All notes associated with this client.</p>
            <ClientNotesList deleteNoteID={deleteNoteID} setDeleteNoteID={setDeleteNoteID} deleteNote={deleteNote} openDeleteNoteModal={openDeleteNoteModal} setOpenDeleteNoteModal={setOpenDeleteNoteModal} setOpenEditNoteModal={setOpenEditNoteModal} openEditNoteModal={openEditNoteModal} editNoteForm={editNoteForm} setEditNoteID={setEditNoteID} editNoteID={editNoteID} editNoteSetup={editNoteSetup} handleEditNote={handleEditNote} handleAddNote={handleAddNote} openAddNoteModal={openAddNoteModal} setOpenAddNoteModal={setOpenAddNoteModal} addNoteForm={addNoteForm} error={error} setError={setError} rows={notesData} totalItems={totalItems} currentPageSize={currentPageSize} setCurrentPageSize={setCurrentPageSize} setFirstRowIndex={setFirstRowIndex} setNoteSearch={setNoteSearch} />
        </Tile>
    )
}

export default ClientNotes